module.exports = __webpack_public_path__ + "img/ico-pay-debt.16000757.svg";